import React, { useEffect, useState } from 'react'
import { MapContainer, Popup, TileLayer, useMap } from 'react-leaflet';
import ReactLeafletKml from 'react-leaflet-kml';
import { GestureHandling } from "@zacwang/leaflet-gesture-handling";
import { useProviderContext } from '../../context/MapProviderContext';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'

import CustomClusterIcon from './CustomClusterIcon';
import ProviderMarker from './ProviderMarker';
import PopUpContent from './Popup/PopUpContent';
import Modal from './Modal';
import { config } from '../../config/config';


function ChangeView({ center, zoom }) {
    const map = useMap();

    map.GestureHandling = {
        gestureHandlingOptions: config.gesture_handling_options
    }
    map.setView(center, zoom);
    map.attributionControl.setPrefix('<a href="https://github.com/Leaflet/Leaflet/blob/main/LICENSE" title="Leaflet LICENSE" target="_blank">Leaflet</a>');
    return null;
}

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

const Map = () => {
    const [kml, setKml] = useState(null);
    const [modal, setModal] = useState(false)

    const {
        isLoading,
        error,
        providers,
        filters,
        options,
        KML_URL,
        config
    } = useProviderContext()

    useEffect(() => {
        fetch(KML_URL)
            .then((res) => res.text())
            .then((kmlText) => {
                const parser = new DOMParser();
                const kml = parser.parseFromString(kmlText, "text/xml");
                setKml(kml);
            });
    }, [KML_URL])

    useEffect(() => {
        setTimeout(() => setModal((options.location_status === 'BAD')), config.map.modal.location_warning.delay)
    }, [config.map.modal.location_warning.delay, options])

    if (isLoading) return config.content.fetch_states.loading;
    if (error) return config.content.fetch_states.error;

    return (
        <div className='w-screen flex flex-col'>
            { modal && (<Modal />) }
            <MapContainer
                center={[options.center.lat, options.center.lng]}
                zoom={7.5}
                className='w-screen min-h-[65vh] max-h-[85vh] h-[85vh]'
                gestureHandling={true}
                id={"map"}
                minZoom={config.map.zoom_level.min}
            >
                <ChangeView center={[options.center.lat, options.center.lng]} zoom={options.zoom} />

                <TileLayer url={process.env.REACT_APP_MB_API_URL} />
                <CustomClusterIcon>
                    {
                        providers.filter(({ information }) => filters.indexOf(information.attributes[0].cssClass) >= 0)
                            .map(({ lat, lng, name, information }, index) => (
                                <ProviderMarker lat={lat} lng={lng} information={information} key={index} index={index}>
                                    <Popup>
                                        <PopUpContent {...{lat, lng, name, information}} />
                                    </Popup>
                                </ProviderMarker>
                            )
                            )
                    }
                </CustomClusterIcon>

                {kml && <ReactLeafletKml kml={kml} />}
            </MapContainer>
        </div>
    );
}

export default Map
